import { styled, Typography } from '@mui/material';

export const StyledTypography = styled(Typography)(({ theme }) => ({
  fontWeight: '500',
  fontSize: theme.styledTheme.newFontSize.get('m'),
}));
